import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';

import Page from '../../../components/pages/service/modals/UserStatus.modal.page.jsx';
import { modelGet, modelActionCall } from '../../../actions/model.actions';
import {
    UserStatusModalContainerCore,
    mapStateToPropsCore,
    mapDispatchToPropsCore
} from 'pluton-core/lib/containers/pages/service/UserStatus.modal.container'
import { homeModel } from 'pluton-core/lib/models/core/home.model';


class UserStatusModalContainer extends UserStatusModalContainerCore {
    render() {
        return (
            <Page {...this.props}
                handleSetHomeStatus={this.handleSetHomeStatus}
            />
        );
    }
}

export default connect(
    mapStateToPropsCore,
    mapDispatchToPropsCore(
        modelActionCall(
            homeModel,
            homeModel.apiSetHomeStatus,
            'POST'
        ),
    )
)(UserStatusModalContainer);



// WEBPACK FOOTER //
// ./app/containers/pages/service/UserStatus.modal.container.jsx